import { Box, Link, Paper } from '@mui/material';
import DOMPurify from 'dompurify';

import useLinkBar from '@/components/LinkBar/useLinkBar';

const LinkBar = () => {
  const { linkUrl, linkMessage } = useLinkBar();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        gap: 3
      }}
    >
      <Paper
        sx={{
          width: '100%',
          height: '48px',
          color: 'text.secondary',
          display: 'flex',
          alignItems: 'center',
          px: 2
        }}
      >
        <Link
          color='text.secondary'
          href={linkUrl}
          rel='noopener noreferrer'
          sx={{ textDecoration: 'none' }}
          target='_blank'
        >
          <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(linkMessage) }} />
        </Link>
      </Paper>
    </Box>
  );
};

export default LinkBar;
